module.exports = __webpack_public_path__ + "images/emoji/watch.9247fc3f142f531c3fa2.png";